module.exports = __webpack_public_path__ + "img/virtualvisit-sef.f196aede.png";